import styled from 'styled-components';

const StyleContainer = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 1.5rem 0;
`;

export { StyleContainer };